import { LayoutDashboard, CalendarPlus, ReceiptText, Stethoscope, Inbox, CalendarDays, History, Users, Sun, UserCircle, ClipboardList, BarChart3, Contact, Building2 } from "lucide-react";

export const ROLE_LABEL = { admin: "Administrator", staff: "Front Desk Staff", doctor: "Doctor" };

const ALL_NAV = [
  { key: "dashboard", label: "Dashboard", icon: LayoutDashboard, roles: ["admin", "staff"] },
  { key: "today", label: "My Day", icon: Sun, roles: ["doctor"] },
  { key: "appointments", label: "Appointments", icon: CalendarPlus, roles: ["admin", "staff"] },
  { key: "appointments", label: "My Patients", icon: CalendarPlus, roles: ["doctor"] },
  { key: "patients", label: "Patients", icon: Contact, roles: ["admin", "staff", "doctor"] },
  { key: "calendar", label: "Calendar", icon: CalendarDays, roles: ["admin", "staff", "doctor"] },
  { key: "doctors", label: "Doctors", icon: Stethoscope, roles: ["admin"] },
  { key: "requests", label: "Booking Requests", icon: Inbox, roles: ["admin", "staff"] },
  { key: "receipts", label: "Receipts", icon: ReceiptText, roles: ["admin", "staff", "doctor"] },
  { key: "summary", label: "Day Summary", icon: ClipboardList, roles: ["admin", "staff"] },
  { key: "reports", label: "Reports", icon: BarChart3, roles: ["admin", "doctor"] },
  { key: "profile", label: "My Profile", icon: UserCircle, roles: ["doctor"] },
  { key: "users", label: "Users", icon: Users, roles: ["admin"] },
  { key: "clinic", label: "Clinic Settings", icon: Building2, roles: ["admin"] },
  { key: "activity", label: "Activity Log", icon: History, roles: ["admin"] },
];

export const navForRole = (role) => ALL_NAV.filter((n) => n.roles.includes(role));
export const homeForRole = (role) => (role === "doctor" ? "today" : "dashboard");

const PERMS = {
  admin: ["appointments:create", "appointments:update", "appointments:delete", "appointments:clinical", "requests:delete", "doctors:write", "users:manage"],
  staff: ["appointments:create", "appointments:update"],
  doctor: ["appointments:clinical"],
};
export const can = (role, action) => (PERMS[role] || []).includes(action);
